/**
 * Redux async actions (src/store/actions/enquiryActions.js).
 *
 * This module defines Redux Toolkit thunks (createAsyncThunk) that call backend endpoints via the shared axios client.
 * Slices consume the fulfilled payloads in `extraReducers` to update the UI state.
 */

import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../helpers/axiosconfig";

/**
 * Async thunk: Delete_Enquiry.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const Delete_Enquiry = createAsyncThunk(
  "Enquiry/Delete_Enquiry",
  async (id) => {
    const response = await axios.delete(`Delete_Enquiry_Student/${id}`);
    
    return response.data;
  }
);

/**
 * Async thunk: FetchAll_Enquiry.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const FetchAll_Enquiry = createAsyncThunk(
  "Enquiry/FetchAll_Enquiry",
  async () => {
    const response = await axios.get(`getenquiries`);
    // remove thisresponse)
    return response.data;
  }
);

/**
 * Async thunk: Create_Enquiry.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const Create_Enquiry = createAsyncThunk(
  "Enquiry/Create_Enquiry",
  async (data) => {
    const response = await axios.post(`Create_Enquiry`, data);
    return response.data.result;
  }
);

/**
 * Async thunk: Create_Enquiry_Student.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const Create_Enquiry_Student = createAsyncThunk(
  "Enquiry/Create_Enquiry_Student",
  async ({ Message }) => {
    const response = await axios.post('v1/enquiries', { Message });
    // remove thisresponse);
    return response.data;
  }
);

export const Delete_Admin_Enquiry = createAsyncThunk(
  "Enquiry/Delete_Admin_Enquiry",
  async (id) => {
    const response = await axios.delete(`admin/enquiries/${id}`);
    return response.data;
  }
);

/**
 * Async thunk: Fetch_Student_Enquiry.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const Fetch_Student_Enquiry = createAsyncThunk(
  "Enquiry/Fetch_Student_Enquiry",
  async (Email) => {
    const response = await axios.get(`Fetch_Enquiry_Student/${Email}`);
    // remove thisresponse)
    return response.data.Enquiry;
  }
);

export const Fetch_Student_Enquiry_Me = createAsyncThunk(
  'Enquiry/Fetch_Student_Enquiry_Me',
  async () => {
    const response = await axios.get('v1/enquiries/me');
    return response.data.Enquiry;
  }
);

// SearchEnquirybyStudentUsername
/**
 * Async thunk: SearchEnquirybyStudentUsername.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const SearchEnquirybyStudentUsername = createAsyncThunk(
  "Enquiry/SearchEnquirybyStudentUsername",
  async (input) => {
    try {
      const response = await axios.post(`SearchEnquirybyStudentUsername/${input}`);
      // remove thisresponse)
      return response;
    } catch (error) {
     
     return error.response.data.message;
    }
  }
);
